import { BODY_MD_MD_STYLES, HEADING_MD_STYLES, HEADING_SM_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const NoDataServerErrorWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: center;
    text-align: center;
`;

export const Header = styled.div`
    ${HEADING_MD_STYLES};
`;

export const SubHeader = styled.div`
    ${HEADING_SM_STYLES};
`;

export const Text = styled.div`
    ${BODY_MD_MD_STYLES}
`;
